module.exports = __webpack_public_path__ + "./images/5af4b560f55dabbc076f145cb1ecbdcb.webp";